/* ---------------------------------------------------------------------------
   Cart page footer: coupon code field + checkout button. Per feedback, the old
   "add order note" textarea is gone (removed from sections/cart-template.liquid),
   replaced by a coupon-code input (#pg-coupon-input) + "החל" apply button
   (#pg-coupon-apply-btn), both rendered server-side in the new .pg-cart-coupon-row
   markup, styled in pg-slider.css.
   There is no public Shopify API to validate/apply a discount code from the cart
   page itself -- discount codes are only ever validated at checkout. So "החל"
   just remembers the typed code (visual confirmation only, no real validation),
   and the standard workaround is used to actually apply it: Shopify's checkout
   accepts a `?discount=CODE` query param that auto-applies a code once the
   customer lands on checkout. This script intercepts the checkout button's click
   (name="checkout", still a normal form submit control) and, if a code was
   entered, redirects straight to `/checkout?discount=...` instead of letting the
   cart form submit normally. If no code was entered, the click falls through and
   the cart form submits exactly as before -- nothing about the existing checkout
   flow changes for customers who don't use a coupon. */
(function () {
  function boot() {
    if (!document.querySelector('form.cart')) return;
    document.addEventListener('click', function (e) {
      var applyBtn = e.target.closest ? e.target.closest('#pg-coupon-apply-btn') : null;
      if (applyBtn) {
        e.preventDefault();
        var input = document.getElementById('pg-coupon-input');
        var code = input ? input.value.trim() : '';
        if (code) {
          try { sessionStorage.setItem('pg_pending_discount_code', code); } catch (err) { /* no-op */ }
          var original = applyBtn.textContent;
          applyBtn.textContent = 'הוחל ✓';
          setTimeout(function () { applyBtn.textContent = original; }, 1600);
        }
        return;
      }
      var checkoutBtn = e.target.closest ? e.target.closest('[name="checkout"]') : null;
      if (!checkoutBtn) return;
      var input2 = document.getElementById('pg-coupon-input');
      var code2 = '';
      try { code2 = sessionStorage.getItem('pg_pending_discount_code') || ''; } catch (err) { /* no-op */ }
      if (!code2 && input2 && input2.value.trim()) code2 = input2.value.trim();
      if (code2) {
        e.preventDefault();
        window.location.href = '/checkout?discount=' + encodeURIComponent(code2);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
